module.exports = __webpack_public_path__ + "img/Group 1419.863399eb.svg";